const R = 'ready';
const P = 'planned';
void P;
export const dispatchNav = [
    {
        label: 'Send goods out', path: '/erp/dispatch', module: 'erp.dispatch', icon: 'Truck', status: R, matchPrefix: true,
        keywords: 'delivery challan fifo pick list batch reservation sales order invoice returnable',
    },
];
//# sourceMappingURL=dispatch.js.map